/**
 * Stable CSS class names for E2E — RPT Topic Management drawer content.
 */
export const RTM_D = {
    root: 'rpt-topic-management-drawer',
    headerRow: 'rpt-topic-management-drawer__header-row',
    titleCol: 'rpt-topic-management-drawer__title-col',
    title: 'rpt-topic-management-drawer__title',
    closeCol: 'rpt-topic-management-drawer__close-col',
    closeIcon: 'rpt-topic-management-drawer-input--icon-close',

    formSection: 'rpt-topic-management-drawer__form-section',
    fieldTopicName: 'rpt-topic-management-drawer-input__topic-name',
    fieldTopicControlDays: 'rpt-topic-management-drawer-input__topic-control-days',

    footerRow: 'rpt-topic-management-drawer__footer-row',
    updateButton: 'rpt-topic-management-drawer-input--button-update',
    saveButton: 'rpt-topic-management-drawer-input--button-save',
} as const;

export const rtmDCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

